/**
 * NgxPermissions role loaded by `AuthService` for administrator profiles.
 * Reuse this constant wherever a route guard or menu entry must be restricted
 * to administrators so both stay on the same permission key.
 */
export const ADMIN_PERMISSION = 'ADMIN';
